import { useQuery } from "@tanstack/react-query";
import { GET_CLIMBER_BY_ID } from "../api/queries";
import { graphQLClient } from "../graphqlClient";

const fetchClimberById = async ({ queryKey }) => {
  const [, { id }] = queryKey;
  const { getClimberById } = await graphQLClient.request(GET_CLIMBER_BY_ID, {
    id,
  });
  const climber = getClimberById[0];

  const userObj = {
    userID: climber.id,
    sub: climber.sub,
    firstName: climber.firstName,
    lastName: climber.lastName,
    username: climber.username,
    role: climber.role,
    email: climber.email,
    shardID: climber.shardID,
    xp: climber.xp,
    userPath: climber.path,
    ladderProgress: climber.ladderProgress,
    facets: climber.facets,
    riasec: climber.riasec,
    profileChoices: climber.profileChoices,
    receivedSurvey: climber.receivedSurvey,
    uniqueIdentifiers: getClimberById.map(({ parentID, path }) => ({
      sectionID: parentID,
      userPath: path,
    })),
  };
  return userObj;
};

export const useGetClimberById = (id, enabled = true) => {
  return useQuery({
    queryKey: id ? ["climber", { id }] : null,
    queryFn: fetchClimberById,
    enabled: !!id && enabled,
  });
};
